export default   class Config{
    //'https://apitest.clickclickrd.com/api/
    static  apiUrl = 'https://api.clickclickrd.com/api/';
    static apiKeyGoogleMaps = 'AIzaSyAvRagR8q0ndcbQwzicBGo9lhHbAxnB2bo';
    static androidStoreUrl = "https://play.google.com/store/apps/details?id=com.GSMData.ClickClickApp&hl=es&gl=US";
}